import React, { useState } from 'react';
import { Card, Title, TextInput, Button } from '@tremor/react';

export function BrandThemingPage() {
  const [formData, setFormData] = useState({
    logo: null,
    primaryColor: '#6366F1',
    secondaryColor: '#4F46E5',
    favicon: null,
    customDomain: ''
  });

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleFileChange = (field, event) => {
    const file = event.target.files[0];
    if (file) {
      setFormData(prev => ({
        ...prev,
        [field]: file
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // TODO: Implement save functionality
    console.log('Saving brand theme:', formData);
  };

  return (
    <div className="space-y-6">
      <Title>Brand Theming</Title>

      <Card>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="space-y-2">
            <label className="text-sm font-medium">Logo Upload</label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleFileChange('logo', e)}
              className="block w-full text-sm text-gray-500
                file:mr-4 file:py-2 file:px-4
                file:rounded-full file:border-0
                file:text-sm file:font-semibold
                file:bg-violet-50 file:text-violet-700
                hover:file:bg-violet-100"
            />
            <p className="text-xs text-gray-500">Recommended size: 200x50px, PNG or SVG</p>
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium">Primary Color</label>
            <div className="flex items-center space-x-2">
              <input
                type="color"
                value={formData.primaryColor}
                onChange={(e) => handleInputChange('primaryColor', e.target.value)}
                className="h-10 w-20"
              />
              <TextInput
                value={formData.primaryColor}
                onChange={(e) => handleInputChange('primaryColor', e.target.value)}
                placeholder="#000000"
              />
            </div>
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium">Secondary Color</label>
            <div className="flex items-center space-x-2">
              <input
                type="color"
                value={formData.secondaryColor}
                onChange={(e) => handleInputChange('secondaryColor', e.target.value)}
                className="h-10 w-20"
              />
              <TextInput
                value={formData.secondaryColor}
                onChange={(e) => handleInputChange('secondaryColor', e.target.value)}
                placeholder="#000000"
              />
            </div>
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium">Favicon</label>
            <input
              type="file"
              accept="image/x-icon,image/png"
              onChange={(e) => handleFileChange('favicon', e)}
              className="block w-full text-sm text-gray-500
                file:mr-4 file:py-2 file:px-4
                file:rounded-full file:border-0
                file:text-sm file:font-semibold
                file:bg-violet-50 file:text-violet-700
                hover:file:bg-violet-100"
            />
            <p className="text-xs text-gray-500">Recommended size: 32x32px, ICO or PNG</p>
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium">Custom Domain</label>
            <TextInput
              value={formData.customDomain}
              onChange={(e) => handleInputChange('customDomain', e.target.value)}
              placeholder="portal.yourbrand.com"
            />
            <p className="text-xs text-gray-500">Enter your custom domain for the admin portal</p>
          </div>

          <div className="flex justify-end space-x-4">
            <Button variant="secondary">Revert to Default</Button>
            <Button type="submit">Save Theme</Button>
          </div>
        </form>
      </Card>
    </div>
  );
} 